// @flow
import Q from 'q';

const CALLABLE_METHOD = 'classWillReceiveFlags';

type TInstanceSignature = { [CALLABLE_METHOD: string]: (...args: boolean[]) => any };
type TUpdateArgs = {
	isFetching: boolean,
	instance: TInstanceSignature,
	shift: number
}
type TRequestStore = {|
	[string]: TInstanceSignature[]
|};

class RequestControl {
	_store: TRequestStore | {} = {};
	_whatIsFetchingNow = {};

	_updateInstance = (params: TUpdateArgs): void => {
		const {shift, isFetching, instance} = params;

		instance[CALLABLE_METHOD](...Array.fill(shift), isFetching);
	};

	_sayAboutFetch = (isFetching: boolean, flag: string): void => {
		this._whatIsFetchingNow[flag] = isFetching;

		(this._store[flag] || []).forEach(item =>
			this._updateInstance({...item, isFetching}),
		);
	};

	method = (METHOD_NAME: string) => wrap(this._sayAboutFetch, METHOD_NAME);

	get = (...methodsName: string[]) => (Constructor: Function) => (...classArgs: any[]) => {
		const instance = new Constructor(...classArgs);

		if (!instance.hasOwnProperty(CALLABLE_METHOD)) { //eslint-disable-line no-prototype-builtins
			throw new Error("[RequestDecorator] Method isn't found");
		}

		(methodsName || []).forEach((methodName: string, shift: number) => {
			const items = this._store[methodName] || [];

			if (this._whatIsFetchingNow[methodName]) {
				this._updateInstance({isFetching: true, shift, instance});
			}

			items.push({
				instance,
				shift, //index in specified sequence Request.controlGet(0,1,2
			});

			this._store[methodName] = items;
		});

		return instance;
	};
}

function wrap (sayAboutFetch: (boolean, string) => void, METHOD_NAME: string) {

	return (target: any, methodName: string, descriptor: { value: string }) => {

		let value = descriptor.value;

		const bound = pointer => async (...args: any[]) => {
			sayAboutFetch(true, METHOD_NAME);

			const response = await Q(value.call(pointer, ...args))
				.catch(e => {
					throw e;
				})
				.finally(() => sayAboutFetch(false, METHOD_NAME));

			return response;
		};

		return {
			configurable: true,
			get () {
				return bound(this);
			},
			set (fn: () => any) {
				value = fn;
			},
		};
	};
}

export const requestControl = new RequestControl();
